import * as React from 'react';

import { Fragment } from 'react';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

type NotificationPropsType = {
  openState: boolean;
  onCloseCallback: (event: React.SyntheticEvent<any> | Event) => void;
  message: string | React.ReactNode;
  alertSeverity: 'success' | 'info' | 'warning' | 'error';
  anchorOrigin?: SnackbarOrigin;
  autoHideDuration?: number|null;
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const Notification = (props: NotificationPropsType) => {
  const {
    openState,
    onCloseCallback,
    message,
    alertSeverity = 'success',
    anchorOrigin = { vertical: 'top', horizontal: 'center' },
    autoHideDuration = 3000,
  } = props;
  return (
    <Fragment>
      <Snackbar open={openState} autoHideDuration={autoHideDuration} onClose={onCloseCallback} anchorOrigin={anchorOrigin}>
        <Alert
          onClose={onCloseCallback}
          severity={alertSeverity}
          sx={{ width: '100%' }}
          iconMapping={{
            success: <CheckCircleRoundedIcon fontSize='inherit' />,
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default Notification;
